import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';

const routes: Routes = [
    {
        path: '',
        component: HomePageComponent,
    },
    // Catch invalid paths under /home. The root '**' wildcard can't be
    // reached across the lazy-load boundary, so redirect them to the 404 page.
    { path: '**', redirectTo: '/404' },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class HomeRoutingModule {}
